// extracted by mini-css-extract-plugin
export default {"updateBtn":"updateBtn--FrWHI"};